import {
  GET_NOTIFICATIONS_REQUEST,
  SHARE_AUDIENCE_REQUEST,
  OPEN_AUDIENCE_REQUEST,
  MARK_ALL_NOTIFICATIONS_AS_READ_REQUEST,
  MARK_NOTIFICATION_AS_READ_REQUEST,
  DELETE_NOTIFICATION_REQUEST,
} from '../constants/action-types';

export const requestNotifications = notify_type => ({
  type: GET_NOTIFICATIONS_REQUEST,
  notify_type,
});

export const requestOpenAudience = id => ({
  type: OPEN_AUDIENCE_REQUEST,
  id,
});

export const requestShareAudience = (id, body) => ({
  type: SHARE_AUDIENCE_REQUEST,
  id,
  body,
});

export const requestDeleteNotification = notificationId => ({
  type: DELETE_NOTIFICATION_REQUEST,
  notificationId,
});

export const requestMarkNotificationAsRead = notificationId => ({
  type: MARK_NOTIFICATION_AS_READ_REQUEST,
  notificationId,
});

export const requestMarkAllNotificationsAsRead = () => ({
  type: MARK_ALL_NOTIFICATIONS_AS_READ_REQUEST,
});
